import {Injectable} from '@angular/core';

import {Observable} from 'rxjs';

@Injectable()
export class UnsavedChangesGuard {

  canDeactivate(component: any): Observable<boolean> | Promise<boolean> | boolean {
    return component && component.canDeactivate ? component.canDeactivate() : true;
  }
}
